export default defineNuxtRouteMiddleware((to) => {
  const page = to.query.page
  if (page === '1') {

    const { page, ...rest } = to.query
    return navigateTo({
      path: to.path,
      query: rest,
    }, { redirectCode: 301 })
  }
})
